// Affiliate Program Task 9 — bind the FirstPromoter attribution cookie to the
// WorkOS user once they are authenticated.
//
// fpr("referral", ...) is idempotent on FP's side (deduplicated by cookie +
// email) and the queue shim in firstpromoter.ts buffers the call if fpr.js is
// still loading, so calling it from more than one landing surface is safe.
//
// AIT-529 / Codex review (P1): it used to live only in RootRedirect. An
// invited signup goes /invite/:slug -> /invite/connect -> /invite/done and
// never mounts RootRedirect, so those conversions — the ones an affiliate is
// actually paid for — were recording the click and never the referral.
import { useEffect, useRef } from 'react';
import { trackSignup } from '@/lib/firstpromoter';

export function useTrackReferralSignup(user: { id?: string; email?: string | null } | null): void {
  const tracked = useRef(false);
  useEffect(() => {
    if (tracked.current) return;
    if (!user?.email || !user?.id) return;
    trackSignup({ email: user.email, uid: user.id });
    tracked.current = true;
  }, [user?.email, user?.id]);
}
